// https://stackoverflow.com/questions/56588625/react-show-material-ui-tooltip-only-for-text-that-has-ellipsis


import React, { useRef, useEffect, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';


function OverflowTip (props){
    // Define state and function to update the value
  const [hoverStatus, setHover] = useState(false);

  // Create Ref
  const textElementRef = useRef();

  const compareSize = () => {
      if(!textElementRef.current) return;
      setTimeout(() => {
        if(!textElementRef.current) return;
        const compare =
            textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
        if(compare !== hoverStatus) setHover(compare);
      }, 100);
  };

  compareSize();

  return (
    <Tooltip
      title={props.value}
      interactive
      disableHoverListener={!hoverStatus}
      style={{fontSize: '2em'}}
    >
      <div
        ref={textElementRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'inline'
        }}
        className={props.className}
      >
        <span>{props.children}</span>
      </div>
    </Tooltip>
  );
};

export default OverflowTip;